import styled from 'styled-components/macro';
import { deviceMin, size } from 'utils/styles/breakpoints';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';
import { FONTS, FONT_FAMILY } from 'utils/styles/fonts';

export const Container = styled.div`
  background: ${COLORS.white};
`;

export const ToursByIdStyle = styled.div`
  background: ${COLORS.lightGray};

  @media ${deviceMin.mobileS} {
    padding: 90px 40px;
  }

  @media ${deviceMin.tablet} {
    padding: 115px 80px;
  }

  @media ${deviceMin.laptopL} {
    padding: 120px 134px;
  }

  @media ${deviceMin.desktop} {
    padding: 120px 286px;
  }

  .titlePrice {
    ${FLEX_CONTAINER.FlexSpaceBetweenRow}
    width: 100%;

    h3 {
      ${FONT_FAMILY.FontMedium}
      color: ${COLORS.mainColor};
      margin-bottom: 12px;

      @media ${deviceMin.mobileS} {
        ${FONTS.font16}
      }

      @media ${deviceMin.tablet} {
        ${FONTS.font16}
      }

      @media ${deviceMin.laptopL} {
        ${FONTS.font20}
      }

      @media ${deviceMin.desktop} {
        ${FONTS.font24}
      }
    }

    span {
      ${FONT_FAMILY.FontBold}
      color: ${COLORS.blue};

      @media ${deviceMin.mobileS} {
        ${FONTS.font16}
      }

      @media ${deviceMin.tablet} {
        ${FONTS.font20}
      }

      @media ${deviceMin.laptopL} {
        ${FONTS.font36}
      }

      @media ${deviceMin.desktop} {
        ${FONTS.font36}
      }
    }
  }

  .desc {
    color: ${COLORS.mainColor};
    ${FONT_FAMILY.FontMedium}
    margin-bottom: 12px;

    @media ${deviceMin.mobileS} {
      ${FONTS.font14}
      margin-top: 12px;
    }

    @media ${deviceMin.tablet} {
      ${FONTS.font14}
    }

    @media ${deviceMin.laptopL} {
      ${FONTS.font16}
    }

    @media ${deviceMin.desktop} {
      ${FONTS.font16}
      margin-top: 30px;
    }
  }

  .iconsWrapper {
    ${FLEX_CONTAINER.FlexRow};

    @media ${deviceMin.mobileS} {
      margin-bottom: 20px;
    }

    @media ${deviceMin.tablet} {
      margin-bottom: 40px;
    }

    p {
      ${FONT_FAMILY.FontMedium}
      ${FONTS.font16}
      color: ${COLORS.mainColor};
      margin-right: 3px;
    }

    svg {
      margin-right: 12px;
    }
  }
`;

export const HotOffersImage = styled.img`
  margin-top: 12px;
  border-radius: 10px;
  object-fit: cover;

  @media ${deviceMin.mobileS} {
    width: 100%;
    height: 210px;
    margin-right: 0;
  }

  @media ${deviceMin.mobileL} {
    height: auto;
    margin-right: 0;
  }

  @media ${deviceMin.tablet} {
    width: 608px;
    height: 373px;
    margin-right: 0;
  }

  @media ${deviceMin.laptopL} {
    width: 557px;
    height: 408px;
    margin-right: 38px;
    margin-bottom: 4px;
  }

  @media ${deviceMin.desktop} {
    width: 715px;
    height: 538px;
    margin-right: 62px;
  }
`;

export const OfferInformation = styled.div``;

export const PriceWrapper = styled.div`
  ${FLEX_CONTAINER.FlexSpaceBetweenRow}
  width: 100%;
`;

export const OfferPriceTitle = styled.h3`
  ${FONT_FAMILY.FontMedium}
  color: ${COLORS.mainColor};
  margin-bottom: 12px;

  @media ${deviceMin.mobileS} {
    ${FONTS.font16}
  }

  @media ${deviceMin.tablet} {
    ${FONTS.font16}
  }

  @media ${deviceMin.laptopL} {
    ${FONTS.font20}
  }

  @media ${deviceMin.desktop} {
    ${FONTS.font24}
  }
`;

export const OfferPrice = styled.span`
  ${FONT_FAMILY.FontBold}
  color: ${COLORS.blue};

  @media ${deviceMin.mobileS} {
    ${FONTS.font16}
  }

  @media ${deviceMin.tablet} {
    ${FONTS.font20}
  }

  @media ${deviceMin.laptopL} {
    ${FONTS.font36}
  }

  @media ${deviceMin.desktop} {
    ${FONTS.font36}
  }
`;

export const StarsImage = styled.img``;

export const OfferDescription = styled.p`
  color: ${COLORS.mainColor};
  ${FONT_FAMILY.FontMedium}
  margin-bottom: 12px;

  @media ${deviceMin.mobileS} {
    ${FONTS.font14}
    margin-top: 12px;
  }

  @media ${deviceMin.tablet} {
    ${FONTS.font14}
  }

  @media ${deviceMin.laptopL} {
    ${FONTS.font16}
  }

  @media ${deviceMin.desktop} {
    ${FONTS.font16}
    margin-top: 30px;
  }
`;

export const InformationBlok = styled.div``;

export const LineAirStyle = styled.img`
  width: 100%;
`;

export const IconWrapper = styled.div`
  ${FLEX_CONTAINER.FlexRow};

  @media ${deviceMin.mobileS} {
    margin-bottom: 20px;
  }

  @media ${deviceMin.tablet} {
    margin-bottom: 40px;
  }

  svg {
    margin-right: 12px;
  }
`;

export const ShareTitle = styled.p`
  ${FONT_FAMILY.FontMedium}
  ${FONTS.font16}
  color: ${COLORS.mainColor};
  margin-right: 3px;
`;

export const SlideImageWrapper = styled.div`
  ${FLEX_CONTAINER.FlexRow};
  flex-wrap: wrap;
  gap: 42px;

  @media only screen and (max-width: ${size.laptopL}) {
    margin-top: 20px;
  }

  @media only screen and (max-width: ${size.tablet}) {
    gap: 28px;
    justify-content: center;
  }
`;

export const Suggestion = styled.img`
  object-fit: cover;
  border-radius: 10px;
  cursor: pointer;
  width: 236px;
  height: 178px;

  @media only screen and (max-width: ${size.laptopL}) {
    width: 144px;
    height: 108px;
  }

  @media only screen and (max-width: ${size.tablet}) {
    width: 168px;
    height: 102px;
  }
`;

export const LinkToWebsite = styled.a`
  ${FLEX_CONTAINER.FlexRow};
`;

export const SocialMediaIcon = styled.img`
  cursor: pointer;
  margin-left: 10px;

  &:hover {
    filter: brightness(0) saturate(100%) invert(18%) sepia(76%) saturate(593%)
      hue-rotate(156deg) brightness(97%) contrast(93%);
    opacity: 0.7;
  }
`;

export const TextBold = styled.span`
  ${FONT_FAMILY.FontBold};
  float: left;
  margin-right: 4px;
`;

export const ToursByIdWrapper = styled.div`
  ${FLEX_CONTAINER.FlexRow}
  align-items: flex-start;

  @media ${deviceMin.mobileS} {
    flex-direction: column-reverse;
  }

  @media ${deviceMin.laptopL} {
    ${FLEX_CONTAINER.FlexRow}
    align-items: flex-start;
  } ;
`;

export const MainImage = styled.img`
  margin-top: 12px;
  border-radius: 10px;
  object-fit: cover;

  @media ${deviceMin.mobileS} {
    width: 100%;
    height: 210px;
    margin-right: 0;
  }

  @media ${deviceMin.mobileL} {
    width: 348px;
    height: 210px;
    margin-right: 0;
  }

  @media ${deviceMin.tablet} {
    width: 608px;
    height: 373px;
    margin-right: 0;
  }

  @media ${deviceMin.laptopL} {
    width: 557px;
    height: 408px;
    margin-right: 38px;
    margin-bottom: 4px;
  }

  @media ${deviceMin.desktop} {
    width: 715px;
    height: 538px;
    margin-right: 62px;
  }
`;

export const ItemsWrapper = styled.div`
  ${FLEX_CONTAINER.FlexRow};
  align-items: unset;
  color: ${COLORS.mainColor};
  margin-bottom: 12px;
  margin-top: 12px;

  strong {
    margin-inline-end: 0.4rem;
    font-weight: 600;
  }
`;

export const StrongText = styled.strong``;

export const HyperlinkText = styled.a`
  color: ${COLORS.mainColor};
  word-break: break-all;
`;
